// const API_BASE_URL =
//   window.location.hostname === "localhost" ||
//   window.location.hostname === "127.0.0.1"
//     ? "http://127.0.0.1:8000/api"
//     : "https://api.kunainital.ac.in/api";

// export default API_BASE_URL;

const hostname = window.location.hostname;

let API_BASE_URL;

if (hostname === "localhost" || hostname === "127.0.0.1") {
  // Local environment
  API_BASE_URL = "http://127.0.0.1:8000/api";
} else if (hostname === "staging-kumaun.isspvtltd.co.in") {
  // Staging environment
  API_BASE_URL ="https://staging-kumaun.isspvtltd.co.in/api";
} else {
  // Live / Production environment
  API_BASE_URL = "https://api.kunainital.ac.in/api";
}

export default API_BASE_URL;


// this is a testing data 

// const hostname = window.location.hostname;

// let API_BASE_URL;

// if (hostname === "localhost" || hostname === "127.0.0.1") {
//   // Local environment
//   API_BASE_URL = "http://127.0.0.1:8000/api";
// } else if (hostname === "staging-kumaun.isspvtltd.co.in") {
//   // Staging environment
//   API_BASE_URL = "https://staging-kumaun.isspvtltd.co.in/api";
// } else {
//   // Live / Production environment
//   API_BASE_URL = "https://api.kunainital.ac.in/api";
// }

// export default API_BASE_URL;

